const tr = {
    translation: {
        LOGIN: "Giriş Yap",
        EMAIL: "E-posta",
        USERNAME: "Kullanıcı Adı",
        ENTER_USERNAME: "Kullanıcı adınızı giriniz",
        INVALID_EMAIL: "Geçerli bir e-posta adresi giriniz",
        ENTER_EMAIL: "E-posta adresinizi giriniz",
        ENTER_PASSWORD: "Şifrenizi giriniz",
        PASSWORD: "Şifre",
        FORGOT_PASSWORD: "Şifremi Unuttum",
        RESET_PASSWORD: "Şifre Sıfırla",
        PASSWORD_RESET_LINK_SENT: "Şifre sıfırlama bağlantısı gönderildi.",
        LOGIN_FAILED: "Giriş başarısız. Lütfen bilgilerinizi kontrol ediniz.",
        DASHBOARD: "Anasayfa",
        GREETING: "Merhaba, {{name}}",
        MENU_FILE: "Dosya",
        MENU_FILE_SETTINGS: "Ayarlar",
        MENU_FILE_PROPAGATION_MODEL: "Yayılım Modeli Ayarları",
        MENU_VIEW: "Görünüm",
        MENU_DB: "Veritabanı",
        MENU_DB_LOAD: "Verici/Alıcı Yükle",
        MENU_CALCULATIONS: "Hesaplamalar",
        MENU_CALCULATIONS_INTERFERENCE: "Enterferans Analizi",
        MENU_CALCULATIONS_CI: "C/I Frekans Kontrolü",
        MENU_CALCULATIONS_TI: "T/I Frekans Kontrolü",
        MENU_CALCULATIONS_IN: "I/N Frekans Kontrolü",
        MENU_CALCULATIONS_TD: "TD Frekans Kontrolü",
        MENU_CALCULATIONS_FIELD_COMPATIBILITY: "Saha Uygunluk Kontrolü",
        MENU_CALCULATIONS_LINK_COMPATIBILITY: "Link Uygunluk Kontrolü",
        MENU_CALCULATIONS_INTERMODULATION: "Entermodülasyon Analizi",
        MENU_CALCULATIONS_INTERMODULATION_FREQUENCY: "Entermodülasyon Frekans Kontrolü",
        MENU_CALCULATIONS_POINT_FIELD_INTENSITY: "Noktasal Alan Şiddeti",
        MENU_CALCULATIONS_SAFETY_ZONE: "Güvenlik Bölgesi Hesaplamaları",
        MENU_CALCULATIONS_SINGLE_SIGNAL: "Tek Sinyal Güvenlik Bölgesi",
        MENU_CALCULATIONS_MULTI_SIGNAL: "Çoklu Sinyal Güvenlik Bölgesi",
        MENU_CALCULATIONS_SHORTWAVE: "Kısa Dalga Frekansları",
        MENU_CALCULATIONS_VECTOR: "Vektör Hesaplamaları",
        MENU_CALCULATIONS_VECTOR_CONTROL_STATION: "Bölge Kontrol İstasyonu",
        MENU_CALCULATIONS_VECTOR_CONTROL_LINK: "Bölge Kontrol Bağlantısı",
        MENU_CALCULATIONS_AREA: "Alan Hesaplamaları",
        MENU_CALCULATIONS_AREA_FIELD_INTENSITY: "Alan Şiddeti Gücü",
        MENU_CALCULATIONS_AREA_CI: "C/I Interferans",
        MENU_CALCULATIONS_AREA_TI: "T/I Interferans",
        MENU_CALCULATIONS_AREA_IN: "I/N Interferans",
        MENU_CALCULATIONS_AREA_PROCESSOR: "İşlemci",
        MENU_CALCULATIONS_AREA_LOW_FREQUENCY: "Düşük Frekans Karışık Mod",
        MENU_CALCULATIONS_AREA_SATELLITE: "Uydu Görüş Hattı",
        MENU_TASKS: "Görevler",
        MENU_COORDINATION: "Koordinasyon",
        MENU_NOTIFICATION: "Bildirim",
        MENU_VIEWING: "Görüntüleme",
        MENU_TEST_OBJECT: "Test Objesi",
        MENU_TEST_CREATE_TRANSMITTERS: "Test Vericileri Oluştur",
        MENU_TEST_CREATE_RECEIVERS: "Test Alıcıları Oluştur",
        MENU_TEST_CREATE_STATION: "Test İstasyonu Oluştur",
        MENU_TEST_CREATE_LINK: "Bağlantı Oluştur",
        MENU_GPS: "GPS",
        MENU_TOOLS: "Araçlar",
        MENU_ICAO: "ICAO",
        MENU_WINDOW: "Pencere",
        MENU_HELP: "Yardım",
        CHECKBOX_OPTION_1: "Seçenek 1",
        CHECKBOX_OPTION_2: "Seçenek 2",
        CHECKBOX_OPTION_3: "Seçenek 3",
        CHECKBOX_OPTION_4: "Seçenek 4",
        CHECKBOX_OPTION_5: "Seçenek 5",
        CHECKBOX_OPTION_6: "Seçenek 6",
        FILE_UPLOAD_TITLE: "Harita Yükleme",
        MAP_TITLE: "Harita",
        UPLOAD_BUTTON: "Yükle",
        MENU_TRANSMITTERS: "Vericiler",
        MENU_RECEIVERS: "Alıcılar",
        MENU_COM_OBJECTS: "COM Nesneleri",
        MENU_VECTOR_RESULTS: "Vektör Sonuçları",
        MENU_SENDER_RECEIVER_LINKS: "Gönderici-Alıcı Bağlantıları",
        MENU_VECTORS: "Vektörler",
        MENU_FAP_VECTORS: "FAP Vektörleri",
        MENU_COVERAGE_AREAS: "Kapsama Alanları",
        MENU_NEAR_AREAS: "Yakın Alanlar",
        MENU_SAFETY_ZONE_AREA: "Güvenlik Bölgesi Alanı",
        MENU_HEIGHT_AREAS: "Yükseklik Alanları",
        MENU_HORIZON_AREAS: "Ufuk Alanları",
        MENU_PROTECTED_SERVICE: "Korunan Hizmet",
        MENU_AREA_RESULTS: "Alan Sonuçları",
        MENU_MAP_LAYERS: "Harita Katmanları",
        MENU_MAP_OSM: "OSM Harita 5m - Türkiye 200km",
        MENU_MAP_DSM: "DSM 50m Türkiye",
        MENU_OBSTACLE_LAYERS: "Engel Katmanları",
        LOGIN_SUCCESS: "Giriş başarılı. Hoş geldiniz!",
        SUCCESS: "Başarılı",
        ERROR: "Hata",
        MEASUREMENT_FIELDS: "Ölçüm Alanları",
        ADD_MEASUREMENT_FIELD: "Ölçüm Alanı Ekle",
        EDIT_MEASUREMENT_FIELD: "Ölçüm Alanı Düzenle",
        FIELD_NAME: "Alan Adı",
        REQUIRED: "Zorunlu",
        ACTIONS: "İşlemler",
        EDIT: "Düzenle",
        DELETE: "Sil",
        YES: "Evet",
        NO: "Hayır",
        DELETE_CONFIRMATION: "Silme Onayı",
        DELETE_MEASUREMENT_FIELD_CONFIRM: "Bu ölçüm alanını silmek istediğinizden emin misiniz?",
        MEASUREMENT_FIELD_ADDED: "Ölçüm alanı başarıyla eklendi.",
        MEASUREMENT_FIELD_UPDATED: "Ölçüm alanı başarıyla güncellendi.",
        MEASUREMENT_FIELD_DELETED: "Ölçüm alanı başarıyla silindi.",
        PLEASE_ENTER_FIELD_NAME: "Lütfen alan adını giriniz",
        ENTER_FIELD_NAME: "Alan adını giriniz",
        FIELD_NAME_MIN_LENGTH: "Alan adı en az 2 karakter olmalıdır",
        FIELD_NAME_MAX_LENGTH: "Alan adı en fazla 50 karakter olabilir",
        ITEMS: "öğe",
        STUDENT_MEASUREMENTS: "Öğrenci Ölçümleri",
        SELECT_STUDENT: "Öğrenci Seçin",
        ADD_MEASUREMENT: "Ölçüm Ekle",
        EDIT_MEASUREMENT: "Ölçüm Düzenle",
        MEASUREMENT_DATE: "Ölçüm Tarihi",
        MEASUREMENT_VALUES: "Ölçüm Değerleri",
        MEASUREMENTS_FOR: "Ölçümler",
        PLEASE_SELECT_STUDENT: "Lütfen önce bir öğrenci seçin",
        MEASUREMENT_ADDED: "Ölçüm başarıyla eklendi.",
        MEASUREMENT_UPDATED: "Ölçüm başarıyla güncellendi.",
        MEASUREMENT_DELETED: "Ölçüm başarıyla silindi.",
        DELETE_MEASUREMENT_CONFIRM: "Bu ölçümü silmek istediğinizden emin misiniz?",
        PLEASE_ENTER_MEASUREMENT_DATE: "Lütfen ölçüm tarihini giriniz",
        PLEASE_ENTER_VALUE: "Lütfen değer giriniz",
        ENTER_VALUE: "Değer giriniz",
        WARNING: "Uyarı",
        ADD_NEW_MEASUREMENT: "Yeni Ölçüm Ekle",
        SAVE_MEASUREMENT: "Ölçümü Kaydet",
        PLEASE_ENTER_AT_LEAST_ONE_VALUE: "Lütfen en az bir değer giriniz",
        EDIT_MEASUREMENT_DESCRIPTION: "Ölçüm bilgilerini düzenleyiniz",
    }
};

export default tr;